<template>
    <q-dialog
    v-model="show"
    persistent
    class="q-dialog-sm"
    >
        <q-card style="overflow: visible">
            <q-card-section class="row items-center q-pb-none">
                <div class="text-h6">Restrict user access to the selected fields</div>
                <q-space />
                <q-btn icon="close" class="q-ml-md" flat round dense v-close-popup />
            </q-card-section>
            <q-card-section style="overflow-y: auto;max-height: 70vh;">
                <q-markup-table
                    flat
                    :loading="loading"
                >
                    <thead>
                    <tr>
                        <th scope="col">Field</th>
                        <th scope="col">Access</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="field in fields" :key="`field_${field.name}`">
                        <td>{{ field.label }}</td>
                        <td>
                            <q-checkbox :model-value="true" label="Read" disable class="q-mr-md" />
                            <q-checkbox v-model="field.write" label="Write" />
                        </td>
                    </tr>
                    </tbody>
                </q-markup-table>
            </q-card-section>
            <q-separator />
            <q-card-actions align="right">
                <q-btn
                    label="Save"
                    flat
                    color="primary"
                    class="q-mt-md"
                    @click="save"
                />
            </q-card-actions>
            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary" />
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>
<script setup>
import {ref, inject, onBeforeUnmount} from "vue"
import {Notify} from "quasar";

const bus = inject('bus')

/**
 * @typedef {{
 *     name: string,
 *     label: string,
 *     write: boolean
 * }} ContactField
 */

/**
 * @type {ToRef<ContactField[]>}
 */
const fields = ref([]);
fields.value = [
    {
        name: 'first_name',
        label: 'First Name',
        write: true
    },
    {
    name: 'virtual_bla',
    label: 'Virtual Bla',
    write: true
}
]

const show = ref(false)
const loading = ref(false)
const controlledUserId = ref(null)

const loadFieldsFromServer = async () => {
    window['APIv2']._request('workspace/fields', {
        workspace_id: window['APIv2'].workspace.id,
    }).then((response) => {
        fields.value = response.list.map((field) => {
            return {
                ...field,
                write: true
            }
        });
    }).catch((err) => {console.log(err)})
};


if(window['APIv2']){
    loadFieldsFromServer()
} else {
    window.addEventListener('APIv2Ready', () => {
        loadFieldsFromServer()
    })
}

const loadUserRestrictions = async (userId) => {
    window['APIv2']._request('workspace/user-restrictions', {
        user_id: userId,
    }).then((response) => {
        const restrictedFields = response['restricted_fields']
        fields.value = fields.value.map((field) => {
            return {
                ...field,
                write: ! restrictedFields.includes(field.name)
            }
        });
    }).catch((err) => {console.log(err)})
};


const showDialog = async (userId) => {
    loading.value = true
    console.log('show dialog')
    console.log(userId)
    controlledUserId.value = userId
    show.value = true
    await loadUserRestrictions(userId)
    loading.value = false
}

// Show dialog by external code request
bus.on('showUserRestrictionsManager', showDialog)

const save = () => {
    const restrictedFields = fields.value.filter((field) => {
        return ! field.write
    }).map((field) => {
        return field.name
    })

    console.log(restrictedFields)

    window['APIv2']._request('workspace/user-restrictions', {
        user_id: controlledUserId.value,
        fields: restrictedFields
    }, 'POST').then((response) => {
        Notify.create({
            message: 'User restrictions saved',
            color: 'positive',
            icon: 'check'
        })

        show.value = false
    }).catch((err) => {console.log(err)})
}
</script>
<style scoped>

</style>
